













import { PropType, defineComponent } from '@vue/composition-api';
import { Message } from '../../dataType';
import Card from './Card.vue';

export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<string>>,
      required: true
    }
  },
  setup() {

  }
});
